export default "__VITE_ASSET__9ad0dca5__"